<template lang="html">
	<div id="wangeditor"></div>
</template>

<script>
	import E from 'wangeditor';
	export default {
		data() {
			return {
				editor: null
			}
		},
		mounted() {
			this.seteditor();
		},
		created() {

		},
		methods: {
			//清空
			clear() {
				this.editor.txt.clear()
			},
			//设置编辑器内容
			setTxt(html) {
				this.editor.txt.html(html)
			},
			seteditor() {
				let that = this;
				this.editor = new E('#wangeditor');
				
				// 设置编辑区域高度为 500px
				this.editor.config.height = 500
				
				//粘贴过滤
				this.editor.config.pasteFilterStyle = false
				
				// 配置 onchange 回调函数
				this.editor.config.onchange = function(newHtml) {
					that.$emit('change', newHtml)
				}
				// 配置触发 onchange 的时间频率，默认为 200ms
				this.editor.config.onchangeTimeout = 500 // 修改为 500ms

				// 配置 图片上传 filename 
				this.editor.config.uploadFileName = 'file';

				// 超时时间
				this.editor.config.uploadImgTimeout = 600 * 1000;

				// 配置 图片上传 接口地址
				this.editor.config.uploadImgServer = this.$H.domain + "common/uploadFile";
				this.editor.config.uploadImgHeaders = {
					token: this.$store.state.userInfo.token
				}
				this.editor.config.uploadImgHooks = {
					// 上传图片之前
					before: function(xhr) {

					},
					// 图片上传并返回了结果，图片插入已成功
					success: function(xhr) {
						console.log('success', xhr)
					},
					// 图片上传并返回了结果，但图片插入时出错了
					fail: function(xhr, editor, resData) {
						console.log('fail', resData)
					},
					// 上传图片出错，一般为 http 请求的错误
					error: function(xhr, editor, resData) {
						console.log('error', xhr, resData)
					},
					// 上传图片超时
					timeout: function(xhr) {
						console.log('timeout')
					},
					// 图片上传并返回了结果
					customInsert: function(insertImgFn, result) {

						insertImgFn(result.result.url)
					}
				}

				this.editor.create();
			}
		}
	}
</script>

<style lang="css">

</style>
